import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String,
  }

  async share (event = undefined) {
    const title = this.titleValue
    const text = this.textValue
    const url = this.urlValue
    const data = { title, text, url }

    if ('share' in navigator) {
      if (navigator.canShare(data)) {
        event?.preventDefault();
        event?.stopPropagation();

        navigator.share(data);
      }
    }
  }
}
